import { Pipe, PipeTransform } from '@angular/core';
import { ToleranzenBezeichnungen } from '../../_overlays/zaehlerverwaltung/zaehler.types';

@Pipe({
  name: 'getAusfallColor',
})
export class AusfallColorPipe implements PipeTransform {
  transform(value: string, tol: ToleranzenBezeichnungen): string {
    switch (value) {
      case tol.TEXT_100_A:
        return tol.COLOR_100;
      case tol.TEXT_L_A:
        return tol.COLOR_L;
      case tol.TEXT_G_A:
        return tol.COLOR_G;
      case 'X':
        return tol.COLOR_100;
      case 'XX':
        return tol.COLOR_L;
      case 'XXX':
        return tol.COLOR_G;
      default:
        return '#d0d0d0';
    }
  }
}
